__turbopack_context__.v({
  "blue": "MetricCard-module__7FgoFa__blue",
  "card": "MetricCard-module__7FgoFa__card",
  "content": "MetricCard-module__7FgoFa__content",
  "icon": "MetricCard-module__7FgoFa__icon",
  "link": "MetricCard-module__7FgoFa__link",
  "orange": "MetricCard-module__7FgoFa__orange",
  "pink": "MetricCard-module__7FgoFa__pink",
  "title": "MetricCard-module__7FgoFa__title",
  "value": "MetricCard-module__7FgoFa__value",
});
